import { Component, OnDestroy, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-mobile-app',
  templateUrl: 'mobile-app.component.html',
  styleUrls: ['mobile-app.component.less'],
  standalone: false
})
export class MobileAppComponent implements OnInit, OnDestroy {
  public readonly currentYear: number = new Date().getFullYear();
  public readonly androidApkUrl =
    'https://fbostorageprod.blob.core.windows.net/fbo-mobile-apps/android/fbo-mobile-app-latest.apk';

  private previousTitle: string;

  constructor(private meta: Meta, private title: Title) {}

  ngOnInit(): void {
    // Keep this page out of search engines while the app is a preview.
    this.previousTitle = this.title.getTitle();
    this.title.setTitle('FlexBackOffice Mobile');
    this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow, noarchive, nosnippet, noimageindex' });
    this.meta.updateTag({ name: 'googlebot', content: 'noindex, nofollow' });
  }

  ngOnDestroy(): void {
    // Remove the noindex directives so other in-app routes are not affected.
    this.meta.removeTag('name="robots"');
    this.meta.removeTag('name="googlebot"');
    if (this.previousTitle) {
      this.title.setTitle(this.previousTitle);
    }
  }
}
